import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  totalItems?: number;
  itemsPerPage?: number;
}
export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  totalItems,
  itemsPerPage = 10
}: PaginationProps) {
  if (totalPages <= 1) return null;
  const getPageNumbers = () => {
    const pages: (number | string)[] = [];
    const maxVisible = 5;
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        pages.push('...');
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push('...');
        pages.push(totalPages);
      }
    }
    return pages;
  };
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems || 0);
  return <div className="flex flex-col sm:flex-row items-center justify-between gap-4 px-4 py-3 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800" data-id="element-995">
      {/* Items info */}
      {totalItems !== undefined && <div className="text-sm text-gray-700 dark:text-gray-300" data-id="element-996">
          Mostrando <span className="font-medium" data-id="element-997">{startItem}</span> a{' '}
          <span className="font-medium" data-id="element-998">{endItem}</span> de{' '}
          <span className="font-medium" data-id="element-999">{totalItems}</span> resultados
        </div>}

      {/* Page numbers */}
      <div className="flex items-center gap-2" data-id="element-1000">
        <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="p-2 rounded-lg border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" aria-label="Página anterior" data-id="element-1001">
          <ChevronLeft size={18} data-id="element-1002" />
        </button>

        <div className="flex gap-1" data-id="element-1003">
          {getPageNumbers().map((page, index) => {
          if (page === '...') {
            return <span key={`ellipsis-${index}`} className="px-3 py-2 text-gray-500 dark:text-gray-400" data-id="element-1004">
                  ...
                </span>;
          }
          return <button key={page} onClick={() => onPageChange(page as number)} className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${currentPage === page ? 'bg-black text-white dark:bg-white dark:text-black' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'}`} data-id="element-1005">
                {page}
              </button>;
        })}
        </div>

        <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className="p-2 rounded-lg border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" aria-label="Página siguiente" data-id="element-1006">
          <ChevronRight size={18} data-id="element-1007" />
        </button>
      </div>
    </div>;
}